import { DatePicker, Select } from 'antd';
import { Plus } from 'lucide-react';

import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import {
  CHART_COMPARE_TERM_TYPE,
  CHART_GRAPH,
} from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import { ChartCompareTermTypeMap } from '@/features/(charts)/chart-renderer/model/chart-maps';
import { getPickerType, getTimezoneDayjs } from '@/utils/time';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartTermCompare = (props: Props) => {
  const { chartInfo } = props;
  const { state } = chartInfo;
  const isCompare = state.target.is_compare;
  const isComboChart = state.graph === CHART_GRAPH.COMBO_CHART;
  const hasMultipleSeries = state.series.length > 1;
  const {
    onAddCompareClick,
    onRemoveCompareClick,
    onCompareTermTypeChange,
    onCustomCompareStartChange,
  } = useChartStateAction(chartInfo);

  const readableDateRange = chartUtils.getReadableDateRangeByCompareTerm(
    state.target.term,
    state.target.compare_term,
  );

  // COMBO_CHART는 compare 기능을 지원하지 않음
  // 다중 시리즈인 경우에도 compare 기능을 지원하지 않음
  if (isComboChart) {
    return null;
  }

  if (!isCompare)
    return (
      <Flex>
        <Button
          variant="ghost"
          leftIcon={<Plus />}
          onClick={onAddCompareClick}
          disabled={hasMultipleSeries}
          tooltip={
            hasMultipleSeries
              ? 'Remove additional data sets to add comparison'
              : undefined
          }
        >
          Add comparison
        </Button>
      </Flex>
    );
  return (
    <VFlex g={12}>
      <Flex j="space-between" a="center">
        <Typo type="label2">Compared to</Typo>
        <Button variant="error_ghost" onClick={onRemoveCompareClick}>
          Remove comparison
        </Button>
      </Flex>
      <Flex g={8}>
        <Select
          value={state.target.compare_term?.type}
          options={ChartCompareTermTypeMap.toArray()}
          style={{ flex: 1 }}
          onChange={onCompareTermTypeChange}
        />
      </Flex>
      {state.target.compare_term?.type === CHART_COMPARE_TERM_TYPE.FIXED && (
        <Flex a="center" g={8}>
          <Typo type="label3" className="text-gray-600">
            Start at
          </Typo>
          <DatePicker
            picker={getPickerType(
              chartUtils.getFrequencyByTermUnit(state.target.term.unit),
            )}
            value={getTimezoneDayjs(state.target.compare_term?.start_date)}
            onChange={onCustomCompareStartChange}
          />
        </Flex>
      )}
      <Typo type="label3" className="text-gray-600">
        {readableDateRange}
      </Typo>
    </VFlex>
  );
};



export default ChartTermCompare;
